import React from "react";
import { Badge } from "react-bootstrap";
import moment from "moment";
import Config from "./Config";
import Enums from "./Enums";

const Utils = {
  setPageTitle: (title) => {
    document.title = title
      ? `${title} | ${process.env.REACT_APP_TITLE}`
      : process.env.REACT_APP_TITLE;
  },
  _apiRequest: async (par) => {
    const {
      path,
      pathParams,
      type,
      payload,
      query,
      dataType = "application/json",
    } = par;
    const apiURI = Utils.prebaseApiUrl({ path, pathParams, query });

    const params = {
      method: type,
      headers: {},
    };

    if (dataType === "application/json") {
      params.headers["Content-Type"] = dataType;
    }

    if (payload && payload !== null) {
      params.body =
        dataType !== "application/json" ? payload : JSON.stringify(payload);
    }
    console.log("apiURI", apiURI, payload);
    const res = await fetch(apiURI, { ...params, credentials: "include" });

    // If 401/403 (token expired), try to refresh token and retry
    // Only skip for /auth/refresh itself to prevent infinite recursion
    const isRefreshPath = path === "/auth/refresh";
    if ((res.status === 401 || res.status === 403) && !isRefreshPath) {
      const refreshed = await Utils._tryRefreshToken();
      if (refreshed) {
        // Retry original request with new token
        const retryRes = await fetch(apiURI, {
          ...params,
          credentials: "include",
        });
        const retryData = await retryRes.json();
        return retryData;
      }
    }
    const data = await res.json();
    return data;
  },
  _isRefreshing: false,
  _tryRefreshToken: async () => {
    // Prevent multiple refresh calls at the same time
    if (Utils._isRefreshing) return false;
    Utils._isRefreshing = true;

    try {
      const refreshURL = Config.getApiURL(Enums.endpoints.auth.REFRESH);
      const res = await fetch(refreshURL, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      Utils._isRefreshing = false;
      return res.ok;
    } catch (err) {
      console.log("Token refresh failed:", err);
      Utils._isRefreshing = false;
      return false;
    }
  },

  prebaseApiUrl: (args) => {
    const { path, pathParams, query } = args;
    let apiUrl = Config.getApiURL(path);
    if (pathParams) {
      Object.keys({ ...pathParams }).forEach((key) => {
        apiUrl = apiUrl.replace("[" + key + "]", pathParams[key]);
      });
    }

    if (query && Object.keys(query).length > 0) {
      console.log("run", query);
      const queryOb = new URLSearchParams(query);
      apiUrl += "?" + queryOb.toString();
    }

    return apiUrl;
  },
  getPublicImage: (imagePath) => {
    return process.env.PUBLIC_URL + imagePath;
  },
  buildBadgeLable: (label, className = "") => {
    switch (label) {
      case "pending":
        return (
          <Badge bg="warning" text="dark">
            {label}
          </Badge>
        );
      case "suspended":
      case "failed":
        return <Badge bg="danger">{label}</Badge>;
      case "unconnected":
        return <Badge bg="secondary">{label}</Badge>;
      case "processing":
        return (
          <Badge bg="warning" text="dark">
            {label}
          </Badge>
        );
      case "connected":
        return <Badge bg="success">{label}</Badge>;
      case "V4":
        return (
          <Badge className={className} bg="info">
            {label}
          </Badge>
        );
      case "V2":
        return (
          <Badge className={className} bg="warning">
            {label}
          </Badge>
        );
      case "V5":
        return (
          <Badge className={className} bg="danger">
            {label}
          </Badge>
        );
      case "UNPAID":
        return (
          <Badge
            className={className}
            bg="custom"
            style={{ backgroundColor: "#f0f0f0" }}
            text="dark"
          >
            {label}
          </Badge>
        );
      case "AWAITING_SHIPMENT":
        return (
          <Badge
            className={className}
            bg="custom"
            style={{ backgroundColor: "#fff3cd" }}
            text="dark"
          >
            {label}
          </Badge>
        );
      case "CANCELLED":
        return (
          <Badge
            className={className}
            bg="custom"
            style={{ backgroundColor: "#dc3545" }}
          >
            {label}
          </Badge>
        );
      case "IN_TRANSIT":
        return (
          <Badge
            className={className}
            bg="custom"
            style={{ backgroundColor: "#004085" }}
          >
            {label}
          </Badge>
        );
      case "DELIVERED":
        return (
          <Badge
            className={className}
            bg="custom"
            style={{ backgroundColor: "#28a745" }}
          >
            {label}
          </Badge>
        );
      case "ON_HOLD":
        return (
          <Badge
            className={className}
            bg="custom"
            style={{ backgroundColor: "#ffc107" }}
            text="dark"
          >
            {label}
          </Badge>
        );
      default:
        return <Badge bg="success">{label}</Badge>;
    }
  },
  dateFormat: (dateStr, fromNow = true) => {
    if (typeof dateStr === "number" && dateStr.toString().length < 11) {
      dateStr = dateStr * 1000;
    }
    const date = new Date(dateStr);
    const dateMM = moment(date);
    const diffFromNow = moment(Date.now()).diff(dateMM, "hours");
    if (fromNow && diffFromNow < 24) {
      return dateMM.fromNow();
    } else {
      return dateMM.format("MMM DD, YYYY - hh:mm A");
    }
  },
  mdRand: (min, max) => {
    return Math.round(Math.random() * (max - min) + min);
  },
  stringToColor: (text) => {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash); // Generate a unique hash
    }
    let color = "#";
    // let rgb = [];
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff; // Convert hash into RGB components
      const darkValue = Math.floor((value / 255) * 128); // Scale to 0-127
      color += ("00" + darkValue.toString(16)).slice(-2); // Use slice instead of substr
    }
    // // Calculate brightness using the perceived brightness formula
    // const brightness = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]);
    // const isDark = brightness < 128; // Dark if brightness is less than 128

    return color;
  },
  getMediaImg: (query) => {
    let imageUrl = Config.getApiURL(Enums.endpoints.media.IMG);

    if (query && Object.keys(query).length > 0) {
      const queryOb = new URLSearchParams(query);
      imageUrl += "?" + queryOb.toString();
    }
    return imageUrl;
  },
};

export default Utils;
